import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { UserApplicationPreferencesApiModel } from './models/userApplicationPreferencesApiModel';

@Injectable()
export class UserApplicationPreferencesApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
    }

    /**
     * Gets the user application preferences
     * associated with the current user
     */
    public getCurrentUserAppPrefs(): Observable<UserApplicationPreferencesApiModel> {
        const slug: string = '/user-app-preferences';

        return this.neptuneApi.api<UserApplicationPreferencesApiModel>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );
    }

    /**
     * Creates a new set of the current user's application preferences
     */
    public createCurrentUserAppPrefs(userAppPrefs: UserApplicationPreferencesApiModel): Observable<void> {
        const slug: string = '/user-app-preferences';

        return this.neptuneApi.api<void>(
            slug,
            userAppPrefs,
            HttpVerbsEnum.POST,
        );
    }

    /**
     * Updates the current user's application preferences
     */
    public updateCurrentUserAppPrefs(userAppPrefs: UserApplicationPreferencesApiModel): Observable<void> {
        const slug: string = '/user-app-preferences';

        return this.neptuneApi.api<void>(
            slug,
            userAppPrefs,
            HttpVerbsEnum.PUT,
        );
    }

    /**
     * Deletes the current user's application preferences completely
     */
    public deleteCurrentUserAppPrefs(): Observable<void> {
        const slug: string = '/user-app-preferences';

        return this.neptuneApi.api<void>(
            slug,
            null,
            HttpVerbsEnum.DELETE,
        );
    }
}
